import React from 'react';
import { StyledPopover } from './styles';
import {IPopover} from './models/PopoverModel';

const Popover = ({ align, children }:IPopover) => {
  return (
    <StyledPopover data-testid="popover" align={align}>
      {children}
    </StyledPopover>
  );
};

export default Popover;
